import { Badge, Card, Col, Row } from "react-bootstrap";
import { EvidenceBlock } from "../common/EvidenceBlock";
import { ScanMulti } from "../common/models";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";

export const SectionSxRxDetails = (props: {
    data: any,
    title: string,
    color?: string,
    scanMulti?: ScanMulti,
}) => {

    if (!props.data) {
        return <></>;
    }

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col className={props.color ?? ""}>
                        <h5>{props.title}</h5>
                    </Col>
                </Row>
                <hr />
                {
                    props.data.symptoms && (
                        <Row className="mb-4">
                            <Col>
                                <div><strong>Symptoms</strong></div>
                                <div className="description-text"><LLMDashboardMarkdownRenderer content={props.data.symptoms} scanMulti={props.scanMulti} /></div>
                            </Col>
                        </Row>
                    )
                }
                {
                    props.data.current_management && (
                        <Row className="mb-4">
                            <Col>
                                <div><strong>Current Management</strong></div>
                                <div className="description-text"><LLMDashboardMarkdownRenderer content={props.data.current_management} scanMulti={props.scanMulti} /></div>
                            </Col>
                        </Row>
                    )
                }
                {
                    props.data.effectiveness && (
                        <Row className="mb-4">
                            <Col>
                                <div><strong>Effectiveness</strong></div>
                                <div className="description-text"><LLMDashboardMarkdownRenderer content={props.data.effectiveness} scanMulti={props.scanMulti} /></div>
                            </Col>
                        </Row>
                    )
                }
                {
                    props.data.recommendations && (
                        <Row className="mb-4">
                            <Col>
                                <div><strong>Recommendations</strong></div>
                                <div className="description-text"><LLMDashboardMarkdownRenderer content={props.data.recommendations} scanMulti={props.scanMulti} /></div>
                            </Col>
                        </Row>
                    )
                }
                {
                    props.data.optimization_recommendations && (
                        <Row className="mb-4">
                            <Col>
                                <div><strong>Optimizations/Recommendations</strong></div>
                                <div className="description-text"><LLMDashboardMarkdownRenderer content={props.data.optimization_recommendations} scanMulti={props.scanMulti} /></div>
                            </Col>
                        </Row>
                    )
                }
                <hr />
                <EvidenceBlock evidence={props.data.evidence.map((evi: any) => {
                    return {
                        ...evi,
                        source: evi.citation,
                        details: evi.content,
                    }
                })} scanMulti={props.scanMulti} />
                {/* {props.data.evidence && props.data.evidence.length > 0 && (
                    <Row className="mb-4">
                        <Col>
                            <div><strong>Supporting Evidence</strong></div>
                            <div className="notes-timeline-container mt-4">
                                {props.data.evidence && props.data.evidence.map((item: any, index: number) => (
                                    <div key={index} className="notes-timeline-item">
                                        <div className="notes-timeline-dot" />
                                        {index !== props.data.evidence.length - 1 && <div className="notes-timeline-line" />}
                                        <div className="notes-timeline-content">
                                            <Row><Col><strong>{item.date}</strong></Col></Row>
                                            <Row className="text-muted"><Col><small>Source: {item.citation}</small></Col></Row>
                                            <Row><Col className="description-text">{item.content}</Col></Row>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                )} */}
            </Card.Body>
        </Card>
    );
};
